import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';

export interface VersionResponse {
  version: string;
}

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private readonly http = inject(HttpClient);

  /**
   * Changing this value will force the app to reload.
   * Remember to also change the app-version.json file.
   */
  private currentAppVersion = environment.APP_VERSION;

  /**
   * Set to true immediately before a version-check reload so beforeunload handlers
   * (e.g. builder unsaved-changes) do not block the reload.
   */
  private versionReloadIntent = false;

  /** True when the app is about to reload for a new version; beforeunload should allow unload. */
  allowUnloadForVersionReload(): boolean {
    return this.versionReloadIntent;
  }

  /** Call immediately before window.location.reload() for a version update. */
  setVersionReloadIntent(value: boolean): void {
    this.versionReloadIntent = value;
  }

  checkVersion(): Observable<VersionResponse> {
    const url = `/app-version.json?t=${Date.now()}`;
    return this.http
      .get<VersionResponse>(url)
      .pipe(catchError(error => throwError(() => error)));
  }

  shouldReload(serverVersion: string): boolean {
    return serverVersion !== this.currentAppVersion;
  }
}
